(function () {
  var STORAGE_KEY = 'sunplanet-announcement-dismissed';

  function getAnnouncementBarElement() {
    return document.querySelector('[data-announcement-bar]');
  }

  function isHomePage() {
    if (document.body.dataset.template === 'index') return true;
    if (document.body.classList.contains('template-index')) return true;

    var bar = getAnnouncementBarElement();
    if (bar && bar.dataset.isHome === 'true') return true;

    var path = window.location.pathname.replace(/\/+$/, '');
    if (path === '') return true;
    return /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  }

  function updateHeaderStack() {
    var announcement = getAnnouncementBarElement();
    var headerBox = document.getElementById('HeaderBox');
    var sHeader = document.querySelector('.s-header');
    var headerTopGap = 12;

    var announcementHeight = 0;
    if (announcement && !announcement.classList.contains('is-dismissed')) {
      announcementHeight = announcement.offsetHeight;
    }

    document.documentElement.style.setProperty('--announcement-bar-height', announcementHeight + 'px');
    document.body.classList.toggle('has-announcement-bar', announcementHeight > 0);

    if (sHeader) {
      document.documentElement.style.setProperty('--header-height', sHeader.offsetHeight + 'px');
    }

    var headerBoxHeight = headerBox ? headerBox.offsetHeight : (sHeader ? sHeader.offsetHeight : 0);
    var stackHeight = announcementHeight + headerTopGap + headerBoxHeight;
    document.documentElement.style.setProperty('--header-stack-height', stackHeight + 'px');
  }

  window.updateHeaderStack = updateHeaderStack;

  function dismissAnnouncementBar() {
    var bar = getAnnouncementBarElement();
    if (!bar || bar.classList.contains('is-dismissed')) return;

    sessionStorage.setItem(STORAGE_KEY, '1');
    bar.classList.add('is-dismissed');
    bar.setAttribute('aria-hidden', 'true');
    updateHeaderStack();
  }

  function applyAnnouncementVisibility() {
    var bar = getAnnouncementBarElement();
    if (!bar) return;

    if (isHomePage()) {
      sessionStorage.removeItem(STORAGE_KEY);
      bar.classList.remove('is-dismissed');
      bar.removeAttribute('aria-hidden');
    } else if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      bar.classList.add('is-dismissed');
      bar.setAttribute('aria-hidden', 'true');
    }

    updateHeaderStack();
  }

  function initAnnouncementDismiss() {
    var bar = getAnnouncementBarElement();
    if (!bar || bar.dataset.dismissInit === 'true') return;

    bar.dataset.dismissInit = 'true';
    applyAnnouncementVisibility();

    bar.addEventListener('click', function (event) {
      if (event.target.closest('.slider-button')) return;
      dismissAnnouncementBar();
    });

    bar.addEventListener('keydown', function (event) {
      if (event.target.closest('.slider-button')) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        dismissAnnouncementBar();
      }
    });
  }

  function observeHeaderStack() {
    var announcement = getAnnouncementBarElement();
    var headerBox = document.getElementById('HeaderBox');

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateHeaderStack);
      return;
    }

    var observer = new ResizeObserver(updateHeaderStack);
    if (announcement) observer.observe(announcement);
    if (headerBox) observer.observe(headerBox);
    window.addEventListener('resize', updateHeaderStack);
  }

  function init() {
    initAnnouncementDismiss();
    updateHeaderStack();
    observeHeaderStack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initAnnouncementDismiss();
    updateHeaderStack();
  });
  document.addEventListener('shopify:section:unload', updateHeaderStack);
  document.addEventListener('shopify:section:reorder', updateHeaderStack);
})();
